import React from 'react';

export interface SolIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const SolIcon: React.FC<SolIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g clipPath="url(#a)"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12.334 1.662v2m0 18v2m-7.78-18.78 1.42 1.42m12.72 12.72 1.42 1.42m-18.78-7.78h2m18 0h2m-18.78 7.78 1.42-1.42m12.72-12.72 1.42-1.42m-2.78 7.78a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.333.662h24v24h-24z"/></clipPath></defs>
    </svg>
  );
};

export default SolIcon;
